import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const calendarSearchSchema = z.object({
  date: z.string().optional(),
  view: z.enum(["day", "week"]).optional(),
  newBooking: z.boolean().optional(),
  clientEmail: z.string().optional(),
  clientId: z.string().optional(),
});

export const Route = createFileRoute("/dashboard/$businessSlug/calendar")({
  validateSearch: calendarSearchSchema,
});
